/* eslint-disable @typescript-eslint/no-explicit-any */

import { DashboardDefaultTabId, ScopeType } from './api';

/**
 * 作用：将后端返回的报表详情数据转换为前端可渲染结构（兼容旧报表数据格式）。
 *
 * 原始实现：`src/pages/datalab/services/customDashboard.ts` -> getDashboard(formatData)
 * 原始引用（used-by）：
 * - `src/pages/datalab/components/DashboardLayout/hooks.ts`
 * - `src/pages/datalab/pages/Multidimensional/Analysis/components/SaveModel/index.tsx`
 */
export function transformDashboardInfo(data: any) {
  const info = JSON.parse(data?.json_metadata || '{}');
  if (info.tabs) {
    data.tabs = info.tabs;
    // 旧数据中没有userFilter, 这里是否遍历增加默认值.
  } else {
    const filters: any[] = [];
    const layouts: any[] = [];
    info?.layout?.forEach((item: any) => {
      if (item?.i?.startsWith('filter')) {
        filters.push(item);
      } else {
        delete item.isDraggable;
        delete item.isResizable;
        layouts.push(item);
      }
    });

    // 为了兼容旧报表保存的筛选器数据中没有scope的情况
    const scopeFilters = filters.map((filter: any) => {
      // scope数据存在 则直接返回
      if (filter?.scope) {
        // 旧数据中taskId转换为String
        filter.scope?.scope_charts?.forEach((chart: any) => {
          chart.task_id = String(chart.task_id);
        });
        return filter;
      }
      const scopeCharts: any = [];
      layouts?.forEach((chart: any) => {
        if (chart?.chart_dataset_list?.some((item: any) => item.table_id === filter?.dataset)) {
          scopeCharts.push({ task_id: String(chart?.task_id), columnDatasetId: filter?.dataset });
        }
      });

      filter.scope = {
        scope_type: ScopeType.SameDataset,
        scope_charts: scopeCharts,
      }; // 给filters中添加scope是为了顶部筛选器浮窗显示

      return filter;
    });

    data.tabs = [
      {
        tabId: DashboardDefaultTabId,
        tabName: '',
        filters: scopeFilters,
        userFilter: { controls: [], show_scope: true },
        layouts,
      },
    ];
  }
  return data;
}

